<template>
  <div>
    <b-card no-body class="p-2 container-card mb-1">
      <b-row>
        <b-col cols="6" class="px-2">
          <upload-file
            @onImportFile="fetchImportCSV"
            :acceptFile="['.csv', '.xls', '.xlsx']"
            :TemplateCSV="templateCSV"
          />
        </b-col>
      </b-row>
      <b-row class="d-flex justify-content-end">
        <b-col cols="6" class="px-2 mb-1">
          <b-form-group
            :label="'Import File'"
            label-for="import-file"
            label-class="font-medium-5 text-white"
          >
            <div>
              <div class="d-flex flex-wrap justify-content-end">
                <v-select
                  v-model="formStatus.status"
                  class="v-select-filter bg-dropdown"
                  :class="formStatus.status ? 'v-select-filter-selected' : null"
                  placeholder="Import Status"
                  :options="statusOption"
                  @input="(option) => onSelectFilter('import_status', option)"
                />
                <div class="search-container mb-1 mb-md-0 mr-0 ml-0 ml-1">
                  <search :on-search-input="onSetValueSearch" />
                </div>
              </div></div
          ></b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :fields="fields"
                :items="importTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table normal-height"
              >
                <template #cell(bloburl)="data">
                  <div>
                    <b-button
                      class="mr-1 template-btn"
                      @click="onClickDownload(data.item.bloburl)"
                    >
                      Download
                    </b-button>
                  </div>
                </template>
                <template #cell(transaction_statusdesc)="data">
                  <div
                    class="inventory-status-import"
                    :class="
                      resolveImportStatusClass(data.item.transaction_status)
                    "
                  >
                    {{ resolveImportStatusLabel(data.item.transaction_status) }}
                  </div>
                </template>
                <template #cell(actions)="data">
                  <div class="d-flex">
                    <icon-detail
                      class="svg-icon mr-4"
                      v-b-tooltip.hover
                      title="Detail"
                      @click.native="routeImportDetail(data.item.importid)"
                    />
                  </div>
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import IconDetail from "@/@core/components/svg/common/IconDetail.vue";
import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import ManageButton from "@/views/components/button/ManageButton.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import useFulfillmentImportFile from "./hooks/useFulfillmentImportFile";
import UploadFile from "@/views/components/upload-file/UploadFile.vue";

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    AddButton,
    Search,
    IconDetail,
    vSelect,
    ManageButton,
    PaginationWithReorder,
    UploadFile,
  },
  setup() {
    const {
      onClickDownload,
      downloadTemplate,
      formStatus,
      statusOption,
      fields,
      loading,
      importTable,
      onSetValueSearch,
      resolveImportStatusLabel,
      resolveImportStatusClass,
      pagination,
      onPageChange,
      routeImportDetail,
      onFilterEntity,
      onSelectFilter,
      fetchImportCSV,
      templateCSV,
    } = useFulfillmentImportFile();
    return {
      onClickDownload,
      downloadTemplate,
      onSetValueSearch,
      formStatus,
      statusOption,
      fields,
      loading,
      importTable,
      resolveImportStatusLabel,
      resolveImportStatusClass,
      pagination,
      routeImportDetail,
      onPageChange,
      onFilterEntity,
      onSelectFilter,
      fetchImportCSV,
      templateCSV,
    };
  },
};
</script>
<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/pages/inventory/history-stock-detail.css";
@import "~@/assets/css/override-styles/status.css";
@import "~@/assets/css/pages/data-management.css";
@import "~@/assets/css/override-styles/tag-dropdown.css";
@import "~@/assets/css/pages/article/create-article.css";
@import "~@/assets/css/override-styles/progress-nav.css";
@import "~@/assets/css/pages/inventory/history-privilege-detail.css";
@import "~@/assets/css/pages/fulfillment/fulfillment-list.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/pages/inventory/history-stock-detail.css";
.template-btn {
  background-color: #5f8d55 !important;
  border-color: #5f8d55 !important;
  padding: 0.5rem 0.8rem;
  border-radius: 0.8rem;
  font-size: 20px;
  width: 120px;
  height: 40px;
}
</style>
